'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _styles = require('../helpers/styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HtmlResource = function (_React$Component) {
  _inherits(HtmlResource, _React$Component);

  function HtmlResource(props) {
    _classCallCheck(this, HtmlResource);

    var _this = _possibleConstructorReturn(this, (HtmlResource.__proto__ || Object.getPrototypeOf(HtmlResource)).call(this, props));

    _this.state = {
      html: null,
      htmlSrc: _this.props.resource.getValue()
    };
    return _this;
  }

  _createClass(HtmlResource, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _bluebird2.default.resolve(_axios2.default.get(this.state.htmlSrc)).then(function (htmlStr) {
        _this2.setState({
          html: { __html: htmlStr.data }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        style: _styles.vastBaseStyle,
        dangerouslySetInnerHTML: this.state.html
      });
    }
  }]);

  return HtmlResource;
}(_react2.default.Component);

HtmlResource.propTypes = {
  resource: _react2.default.PropTypes.object.isRequired,
  request: _react2.default.PropTypes.object
};

exports.default = HtmlResource;
//# sourceMappingURL=html-resource.js.map


// WEBPACK FOOTER //
// ./src/resources/html-resource.js